import axios, { AxiosResponse } from "axios";
import {
  HunterCompanyDto,
  HunterEmployeeDto,
} from "../models/admin.model";

export const getHunterCompany = async (keyword: string): Promise<AxiosResponse<{data: HunterCompanyDto[]}>> => {
  const res = await axios.get(`/hunter/search?keyword=${keyword}`);
  return res;
};

export const getHunterEmployee = async (company: string): Promise<AxiosResponse<{data: HunterEmployeeDto}>> => {
  const res = await axios.get(`/hunter/view?company=${company}`);
  return res;
};

export const createNotification = async (title: string, body: string): Promise<AxiosResponse<any>> => {
  const res = await axios.post(`/notification/admin/send-notis`, { title, body });
  return res;
};
